<template>
  <div
    class="season_length_container d-flex-column justify-start align-start gap-5 flex-8"
    ref="lengtContainerRef"
  >
    <div class="d-flex-row space-between">
      <h5 class="t-white bold-xl font-family-2">{{ seasonLength?.title }}</h5>
    </div>
    <div class="progress-container">
      <div
        v-for="(item, index) in blockCount"
        :key="index"
        class="progress-item"
        :class="[getClass(index + 1)]"
      ></div>
    </div>
    <div class="d-flex-row space-between">
      <h5 class="t-grey medium-s font-family-2">{{ parsedStartDate }}</h5>
      <h5 class="t-grey medium-s font-family-2">{{ parsedEndDate }}</h5>
    </div>
  </div>
</template>

<script setup>
import TpReviews from "../common/sections/boosting/TpReviews.vue";
const boxWidth = 9;
const props = defineProps({
  seasonLength: {
    default: {},
  },
});

const numberOfSeasonDays = computed(() => {
  if (!props.seasonLength?.id) return 0;
  const startDate = new Date(props.seasonLength?.start_at);
  const endDate = new Date(props.seasonLength?.end_at);

  const timeDifference = endDate - startDate;
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

  return daysDifference;
});

const lengtContainerRef = ref(null);
const passedDays = computed(() => {
  if (!props.seasonLength?.id) return 0;
  const startDate = new Date(props.seasonLength?.start_at);
  const endDate = new Date();

  const timeDifference = endDate - startDate;
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  if (daysDifference < 0) {
    return 0;
  }
  if (daysDifference > numberOfSeasonDays.value) {
    return numberOfSeasonDays.value;
  }
  return daysDifference;
});

const parsedStartDate = computed(() => {
  if (!props.seasonLength?.id) return "";

  const dateStart = new Date(props.seasonLength?.start_at);
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(dateStart);
  // .replace(/\//g, ".");
  return formattedDate;
});

const parsedEndDate = computed(() => {
  if (!props.seasonLength?.id) return "";

  const dateStart = new Date(props.seasonLength?.end_at);
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(dateStart);
  // .replace(/\//g, ".");
  return formattedDate;
});

const blockCount = ref(0);
const getClass = (index) => {
  const itemPr = Math.floor((index / blockCount.value) * 100);
  if (itemPr <= percentage.value) {
    return "active";
  }
  return "";
};
const percentage = computed(() => {
  const pr = (passedDays.value / numberOfSeasonDays.value) * 100;

  return Math.ceil(pr);
});

const handleResize = () => {
  try {
    const el = lengtContainerRef.value;
    if (el) {
      const width = el.getBoundingClientRect()?.width;
      blockCount.value = Math.floor(width / boxWidth);
      console.log(blockCount.value);
    }
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});
</script>
